import { AxiosResponse } from 'axios';
import { ISendMessageRequestData, IChatResponse } from '../types/api/chatApi';
import { getAuthToken } from '../utils/commonHelper';
import { IChatRequestData } from '../types/common';
import axiosInstance from '../utils/AxiosInstance';

const API_URL = `${process.env.REACT_APP_API_URL}/chat`; // Replace with your actual API URL


const customHeaders = {
  'content-type': 'application/json',
  'Authorization': `Bearer ${getAuthToken()}`
};

export const getChatDataService = async ({ user1, user2 }: IChatRequestData): Promise<AxiosResponse<IChatResponse>> => {
  try {
    let url = `${API_URL}/${user1}/${user2}`;

    const response = await axiosInstance.get(url, { headers: customHeaders });
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const sendMessageService = async (data: ISendMessageRequestData): Promise<AxiosResponse<IChatResponse>> => {
  try {
    let url = `${API_URL}/send`;
    const response = await axiosInstance.post(url, data, { headers: customHeaders });
    return response;
  } catch (error: any) {
    throw error;
  }
};




